import { Grid } from "@material-ui/core";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { ErrorModal } from "../../../components/modals/error-modal";
import { getUTLSettings } from "../../../repositorie/MESF-frontend-Repositorie";
import { TableSettings } from "./components/TableSettings";
import { useSettingsContext } from "./context/SettingsContext";
import { Setting } from "./models/Setting";

export const SettingsPage = () => {
	const { state, actions } = useSettingsContext();
	const [error, setError] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const getSettingsFromAPI = async () => {
		setIsLoading(true);
		const res = await getUTLSettings();
		if (res.ok) {
			const settings = get(res, "data.tables[0].rows", []) as Setting[];
			actions.setSettings(settings);
		} else {
			setError(res.message);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getSettingsFromAPI();
	}, []);

	return (
		<>
			<Grid container justifyContent="center" alignItems="center">
				<div style={{ width: "100%", padding: "10px 0 20px" }}>
					<TableSettings
						rows={state.settings}
						isLoading={isLoading}
						getSettingsFromAPI={getSettingsFromAPI}
					/>
				</div>
			</Grid>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
